import { z } from 'zod';

const formBookingDatepickerSchema = (
  isBlockedTime: (date: Date) => boolean
) => {
  return z.discriminatedUnion('timeTabs', [
    z.object({
      date: z.date({
        required_error: 'schemas.common.dateRequired'
      }),
      time: z
        .object(
          {
            from: z.string(),
            to: z.string(),
            status: z.string()
          },
          {
            required_error: 'schemas.common.timeRequired'
          }
        )
        .superRefine((obj, ctx) => {
          if (!obj.from && !obj.to) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'schemas.common.timeRequired'
            });
          }
        }),
      timeTabs: z.literal<string>('default')
    }),
    z.object({
      date: z
        .date({
          required_error: 'schemas.common.dateRequired'
        })
        .superRefine((value, ctx) => {
          if (isBlockedTime(value)) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'schemas.common.scheduleNotAvailable'
            });
            return;
          }

          const isOpenOrganization = !(
            value.getHours() >= 11 && value.getHours() <= 19
          ); // TODO: Cambiar a la apertura de la escuela
          if (isOpenOrganization) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: 'schemas.common.scheduleInvalid'
            });
            return;
          }
        }),
      time: z.undefined(),
      timeTabs: z.literal<string>('custom')
    })
  ]);
};

export default formBookingDatepickerSchema;
